/* eslint-disable camelcase */

import isFoundationProductVariantUtil from 'modules/product-variant/utils/is-foundation'
import isConcealerFoundationProductVariantUtil from 'modules/product-variant/utils/is-concealer'

/**
 * @param {ProductVariantCollection} featuredProductVariant
 * @returns {boolean}
 */
const isFoundationOrConcealerFoundationProductVariantUtil = ({ featuredProductVariant }) => {
  return (
    isFoundationProductVariantUtil({ featuredProductVariant }) ||
    isConcealerFoundationProductVariantUtil({ featuredProductVariant })
  )
}

export default isFoundationOrConcealerFoundationProductVariantUtil
